<div class="flex flex-1 flex-col gap-2">
  <dx-form
    [formData]="formData"
    (onFieldDataChanged)="onFieldDataChanged()"
    [colCount]="1"
    [readOnly]="readonly"
  >
    <dxi-item
      dataField="title"
      [label]="{
        visible: false
      }"
      [editorOptions]="{
        placeholder: 'Titolo' | transloco,
        valueChangeEvent: 'keyup'
      }"
    ></dxi-item>
    <!--
    <dxi-item
      dataField="dataType"
      editorType="dxSelectBox"
      [editorOptions]="{
        valueExpr: 'value',
        displayExpr: 'display',
        dataSource: [
          { value: 'text', display: 'Testo' | transloco },
          { value: 'textmultiline', display: 'Testo multiline' | transloco },
          { value: 'number', display: 'Numerico' | transloco },
          { value: 'date', display: 'Data' | transloco },
          { value: 'datetime', display: 'Data ed ora' | transloco }
        ]
      }"
      [label]="{
        text: 'Tipo' | transloco,
        location: 'left',
        showColon: false
      }"
    ></dxi-item>
    -->
  </dx-form>
</div>
